import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { Clocking } from '@app/entities/models/mot/clocking/clocking.model';

export interface ClockingRepository {
  getClockings(): Observable<Clocking>;
}

export const CLOCKING_REPOSITORY = new InjectionToken<ClockingRepository>('CLOCKING_REPOSITORY');
